// src/store/slices/counterSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const counterSlice = createSlice({
  name: "counter",
  initialState: { value: 0 },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementAsync: () => {}, // saga will handle this
  },
});

export const { increment, decrement, incrementAsync } = counterSlice.actions;
export default counterSlice.reducer;
